import { connect, useDispatch } from 'react-redux';
import { submit } from 'redux-form';
import * as $ from 'jquery';
import { examUpdate, examSecureFax, emailPrescriptionReportSend, examEditCancel, examPdfLink } from '../../../redux/actions/exam/examActions';
import ExamForm from '../exam/ExamForm';
import { openInNewTab } from '../../../itrust_common/components/HelperFunctions';
import { useEffect } from 'react';

function EditExamModal(props) {
  const { exam, activeTab, examEditing } = props;
  const dispatch = useDispatch()

  useEffect(() => {
    if (!examEditing) {
      $('#editExamForm-modal').modal('hide');
    }
  }, [examEditing])

  const handleExamSubmit = async (data) => {

    data = await handleDataValidate(data)
   await  dispatch(examUpdate(data, { include: '*' }))
  }

  const handleDataValidate = (data) => {
    if (data.internal_attributes?.instilled_at) {
      return validateInternalInstilled(data)
    }
    return data
  }

  const validateInternalInstilled = (data) => {
    let { instilled_at } = data.internal_attributes;
    // Remove time zone abbreviation (e.g., "IST", "PST")
    instilled_at = instilled_at.replace(/\s[A-Z]{2,4}$/, '');
    // Validate and convert to ISO format (as per BE requirement) if valid
    const parsedDate = new Date(instilled_at);
    if (!isNaN(parsedDate.getTime())) {
      instilled_at = parsedDate.toISOString();
    }
    // Return updated data with modified `instilled_at`
    return {
      ...data,
      internal_attributes: {
        ...data.internal_attributes,
        instilled_at
      }
    };
  }

  const handleRemoteSubmit = (form) => {
    dispatch(submit(form))
  }

  const handleExamSecureFax = (data) => {
    dispatch(examSecureFax(exam.id, data))
  }

  const handleEmailPrescriptionReportSend = () => {
    handleSaveBeforePrint()
    dispatch(emailPrescriptionReportSend(exam.id))
  }

  const handleExamEditCancel = () => {
    dispatch(examEditCancel())
  }

  const handleExamPdfPrint = async () => {
    handleSaveBeforePrint()
    const url = `exams/${exam.id}/overview`
    let printLink = await dispatch(examPdfLink({ exam_print_url: url }))
    openInNewTab(printLink.value.data.filepath)
  }

  const handleSaveBeforePrint = () => {
    switch (activeTab) {
      case 2: handleRemoteSubmit('examHpiForm'); break
      case 6: handleRemoteSubmit('examPreliminaryBinocularForm'); break
      case 7: handleRemoteSubmit('examRefractionContactLensForm'); break
      case 8: handleRemoteSubmit('examExternalInternalForm'); break
      case 9: handleRemoteSubmit('examAdditionalTestForm'); break
      case 11: handleRemoteSubmit('examFinalizePrescriptionForm'); break
      default:
    }
  }

  return (
    <div className="exam-setting-modal exam-modal">
      <div className="modal fade hidden-scroll pr-0" id="editExamForm-modal" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div className="modal-dialog m-0" role="document">
          <div className="modal-content bg-light">
            {exam.id &&
              <ExamForm
                onSubmit={handleExamSubmit}
                onSecurFax={handleExamSecureFax}
                handleEmailPrescriptionReportSend={handleEmailPrescriptionReportSend}
                handleExamEditCancel={handleExamEditCancel}
                handleExamPdfPrint={handleExamPdfPrint}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const { exam, other, setting: { orgConfig } } = state;
  return {
    exam: exam.exam,
    examEditing: exam.editing,
    activeTab: other.activeTab.exam,
    examViewModern: orgConfig.org_config?.exam_settings?.view_mode == 'modern',
    showOverviewModal: other.activeTab.showOverviewModal,
  };
}

export default connect(mapStateToProps)(EditExamModal);
